// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rbc-calendar {
    padding: 0rem 1rem 0 1rem;
    height: 82vh;
}

.dark-calendar .rbc-off-range-bg {
    background-color: #2b3035;
}

.dark-calendar .rbc-today {
    background-color: #161718;
}

.dark-calendar button {
    background-color: #2b3035;
    color: lightgray;
}

.dark-calendar button.rbc-active,
.dark-calendar button.rbc-active:hover,
.dark-calendar button.rbc-active:active,
.dark-calendar button.rbc-active:focus,
.dark-calendar button:hover,
.dark-calendar button:active,
.dark-calendar button:active:hover,
.dark-calendar button:focus {
    background-color: #141618;
    color: lightgray;
}

.dark-calendar .rbc-label {
    color: lightgray;
}

.dark-calendar .rbc-timeslot-group:nth-of-type(2n) {
    background-color: #141618;
}

.dark-calendar .rbc-timeslot-group, 
.dark-calendar .rbc-time-view,
.dark-calendar .rbc-time-content,
.dark-calendar .rbc-time-slot,
.dark-calendar .rbc-time-slot {
    border-color: gray;
}

.dark-calendar .rbc-current-time-indicator {
    height: 2px;
    background-color: lightgreen;
}

.rbc-toolbar button{
    padding: 0.375rem 0.6rem;
}

.log-checkbox.form-check, .group-checkbox.form-check {
    display: flex ;
    justify-content: center;
    gap: 0.25rem;
}

.form-check label,
.form-check .form-check-input {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.log-checkbox.form-check label,
.group-checkbox.form-check label {
    padding: 0 0.25rem;
    border-radius: 5px;    
}

.log-checkbox.form-check label{
    background-color: #ead2ac;
    color: #363636;
}

.group-checkbox.form-check label {
    background-color: #557722;
    color: white;
}

.rbc-event.rbc-selected {
    background-color: #265985;
}

.modal-footer .form-text {
    font-size: 0.7rem;
    position: absolute;
    left: 0px;
    bottom: 0px;
    margin: 0 0px 0 5px;
}

td.rbc-agenda-event-cell {
    cursor: pointer;
}

@media (max-width: 575px) {
    .log-checkbox.form-check, .group-checkbox.form-check {
        font-size: 0.8rem;
        gap: 0.25rem;
        padding: 0;
    }

    .rbc-toolbar {
        font-size: 0.8rem;
    }

    .rbc-toolbar .form-control {
         font-size: 0.8rem;
    }

    .rbc-toolbar .input-group .input-group-text button {
        font-size: 0.8rem;
    }

    .rbc-calendar {
        font-size: 0.8rem;
        padding: 0.25rem;
    }

    .rbc-event {
        padding: 0.05rem;
        font-size: 0.7rem;
    }

    .rbc-label {
        padding: 0 0.05rem;
    }
}

@media (max-width: 767px) {

    .rbc-calendar {
        padding: 0rem 1rem 0 1rem;
        height: 75vh;
    }

    .rbc-toolbar {
        flex-direction: column;
        gap: 0.25rem;
    }

    .rbc-toolbar button{
        padding: 0.375rem 1rem;
    }

    .rbc-toolbar .input-group {
        width: 85% !important;
        padding: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Usercalendar/Usercalendar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;;;;;;;IAQI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;IAKI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;QACjB,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;SACK,iBAAiB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;QACI,yBAAyB;QACzB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ","sourcesContent":[".rbc-calendar {\r\n    padding: 0rem 1rem 0 1rem;\r\n    height: 82vh;\r\n}\r\n\r\n.dark-calendar .rbc-off-range-bg {\r\n    background-color: #2b3035;\r\n}\r\n\r\n.dark-calendar .rbc-today {\r\n    background-color: #161718;\r\n}\r\n\r\n.dark-calendar button {\r\n    background-color: #2b3035;\r\n    color: lightgray;\r\n}\r\n\r\n.dark-calendar button.rbc-active,\r\n.dark-calendar button.rbc-active:hover,\r\n.dark-calendar button.rbc-active:active,\r\n.dark-calendar button.rbc-active:focus,\r\n.dark-calendar button:hover,\r\n.dark-calendar button:active,\r\n.dark-calendar button:active:hover,\r\n.dark-calendar button:focus {\r\n    background-color: #141618;\r\n    color: lightgray;\r\n}\r\n\r\n.dark-calendar .rbc-label {\r\n    color: lightgray;\r\n}\r\n\r\n.dark-calendar .rbc-timeslot-group:nth-of-type(2n) {\r\n    background-color: #141618;\r\n}\r\n\r\n.dark-calendar .rbc-timeslot-group, \r\n.dark-calendar .rbc-time-view,\r\n.dark-calendar .rbc-time-content,\r\n.dark-calendar .rbc-time-slot,\r\n.dark-calendar .rbc-time-slot {\r\n    border-color: gray;\r\n}\r\n\r\n.dark-calendar .rbc-current-time-indicator {\r\n    height: 2px;\r\n    background-color: lightgreen;\r\n}\r\n\r\n.rbc-toolbar button{\r\n    padding: 0.375rem 0.6rem;\r\n}\r\n\r\n.log-checkbox.form-check, .group-checkbox.form-check {\r\n    display: flex ;\r\n    justify-content: center;\r\n    gap: 0.25rem;\r\n}\r\n\r\n.form-check label,\r\n.form-check .form-check-input {\r\n    cursor: pointer;\r\n    user-select: none;\r\n}\r\n\r\n.log-checkbox.form-check label,\r\n.group-checkbox.form-check label {\r\n    padding: 0 0.25rem;\r\n    border-radius: 5px;    \r\n}\r\n\r\n.log-checkbox.form-check label{\r\n    background-color: #ead2ac;\r\n    color: #363636;\r\n}\r\n\r\n.group-checkbox.form-check label {\r\n    background-color: #557722;\r\n    color: white;\r\n}\r\n\r\n.rbc-event.rbc-selected {\r\n    background-color: #265985;\r\n}\r\n\r\n.modal-footer .form-text {\r\n    font-size: 0.7rem;\r\n    position: absolute;\r\n    left: 0px;\r\n    bottom: 0px;\r\n    margin: 0 0px 0 5px;\r\n}\r\n\r\ntd.rbc-agenda-event-cell {\r\n    cursor: pointer;\r\n}\r\n\r\n@media (max-width: 575px) {\r\n    .log-checkbox.form-check, .group-checkbox.form-check {\r\n        font-size: 0.8rem;\r\n        gap: 0.25rem;\r\n        padding: 0;\r\n    }\r\n\r\n    .rbc-toolbar {\r\n        font-size: 0.8rem;\r\n    }\r\n\r\n    .rbc-toolbar .form-control {\r\n         font-size: 0.8rem;\r\n    }\r\n\r\n    .rbc-toolbar .input-group .input-group-text button {\r\n        font-size: 0.8rem;\r\n    }\r\n\r\n    .rbc-calendar {\r\n        font-size: 0.8rem;\r\n        padding: 0.25rem;\r\n    }\r\n\r\n    .rbc-event {\r\n        padding: 0.05rem;\r\n        font-size: 0.7rem;\r\n    }\r\n\r\n    .rbc-label {\r\n        padding: 0 0.05rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\r\n    .rbc-calendar {\r\n        padding: 0rem 1rem 0 1rem;\r\n        height: 75vh;\r\n    }\r\n\r\n    .rbc-toolbar {\r\n        flex-direction: column;\r\n        gap: 0.25rem;\r\n    }\r\n\r\n    .rbc-toolbar button{\r\n        padding: 0.375rem 1rem;\r\n    }\r\n\r\n    .rbc-toolbar .input-group {\r\n        width: 85% !important;\r\n        padding: 0;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
